var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBybit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3158 18.6573V11.783H23.6976V18.6573H22.3158Z",
    fill: "#F7A600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21205 20.6992H3.24982V13.8249H6.09293C7.47471 13.8249 8.27983 14.578 8.27983 15.756C8.27983 16.5185 7.76275 17.0112 7.40485 17.1753C7.83206 17.3683 8.3789 17.8027 8.3789 18.7203C8.3789 20.004 7.47471 20.6992 6.21205 20.6992ZM5.98356 15.0223H4.63158V16.6058H5.98356C6.56996 16.6058 6.89807 16.2871 6.89807 15.8138C6.89807 15.341 6.56996 15.0223 5.98356 15.0223ZM6.0729 17.8127H4.63158V19.5023H6.0729C6.69935 19.5023 6.99714 19.1163 6.99714 18.6525C6.99714 18.1892 6.69879 17.8127 6.0729 17.8127Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5934 17.88V20.6992H11.2214V17.88L9.09409 13.8249H10.595L11.9172 16.5958L13.2194 13.8249H14.7202L12.5934 17.88Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6376 20.6992H15.6754V13.8249H18.5185C19.9003 13.8249 20.7054 14.578 20.7054 15.756C20.7054 16.5185 20.1883 17.0112 19.8304 17.1753C20.2576 17.3683 20.8045 17.8027 20.8045 18.7203C20.8045 20.004 19.9003 20.6992 18.6376 20.6992ZM18.4091 15.0223H17.0571V16.6058H18.4091C18.9955 16.6058 19.3236 16.2871 19.3236 15.8138C19.3236 15.341 18.9955 15.0223 18.4091 15.0223ZM18.4985 17.8127H17.0571V19.5023H18.4985C19.1249 19.5023 19.4227 19.1163 19.4227 18.6525C19.4227 18.1892 19.1249 17.8127 18.4985 17.8127Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.151 15.0223V20.6997H26.7692V15.0223H24.9202V13.8249H30V15.0223H28.151Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBybit);
export default __webpack_public_path__ + "static/media/ic_bybit.04e6a46fe6debe00d2e20857ec4325fa.svg";
export { ForwardRef as ReactComponent };